const size = {
  tablet: "1020px",
  mobleL: "767px",
  mobleS: "600px",
};

export const device = {
  tablet: `( max-width: ${size.tablet})`,
  mobileL: `( max-width: ${size.mobleL})`,
  mobileS: `( max-width: ${size.mobleS})`,
};
